import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';

export default function PhoneNumberComponent({ control, name, disabled }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ minLength: { value: 10, message: 'Min length should be 10' } }}
      render={({ field, fieldState }) => (
        <>
          <NumberFormat
            className="input-shadow w-100 p-2 border-0 number-format p-inputtext"
            placeholder="Type in"
            format="(###) ###-####"
            mask="_"
            name="phone"
            keyfilter={'pnum'}
            onValueChange={(e) => field.onChange(e.value)}
            value={field.value}
            disabled={disabled}
          />
          {fieldState.error?.message && <InputErrorMessage className="text-danger d-block">{fieldState.error?.message}</InputErrorMessage>}
        </>
      )}
    />
  );
}
